import React from 'react';

import {
  SidePage,
  Section,
  DescriptionList,
  DescriptionItem,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Stack,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';
import { useScreenGo } from '@gogame/screens';

import Actions from 'scenes/Integrations/components/Actions';
import {
  IntegrationPostbackFormEdit,
  IntegrationPostbackFormDuplicate,
} from 'scenes/Integrations/components/IntegrationForm';
import { TYPE_POSTBACK } from 'scenes/Integrations/constants';
import {
  useLoadPostbackDetails,
  useIsUpdatingPostback,
} from 'scenes/Integrations/data';

import Metadata from './Metadata';

// TODO: uncommented Action Log with tab after implement server side
// import ActionsLog from './ActionsLog';
//
// const TAB_DETAILS = 'Details';
// const TAB_ACTIONS_LOG = 'Actions Log';

const IntegrationPostbackDetails = ({
  id,
  onClose,
  onExited,
  open,
  // activeTabId = TAB_DETAILS,
}) => {
  const [childComponent, openChildComponent] = useChildComponent();
  const { data, isLoading, isRefetching } = useLoadPostbackDetails(id);
  const isUpdating = useIsUpdatingPostback();
  const go = useScreenGo();

  const handleDuplicate = () => {
    openChildComponent(IntegrationPostbackFormDuplicate, {
      id,
      onSubmit: ({ typeId, id }) => {
        go(`${typeId}/${id}`);
      },
    });
  };

  const handleEdit = () => {
    openChildComponent(IntegrationPostbackFormEdit, {
      id,
    });
  };

  const handleRemove = () => {
    onClose();
  };

  const affiliatesLength = data?.affiliates?.length;

  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading}
      fetching={isRefetching || isUpdating}
      open={open}
      size={'lg'}
    >
      <SidePage.Title
        title={'Integration'}
        entityId={id}
        subTitle={
          affiliatesLength
            ? affiliatesLength === 1
              ? data.affiliates[0].name
              : `${affiliatesLength} Affiliates`
            : null
        }
      />
      {/*<SidePage.Tabs activeTabId={activeTabId}>*/}
      {/*  <SidePage.Tab label={TAB_DETAILS}>*/}
      <SidePage.NewBody wrapper={true} dense={true}>
        <SidePage.NewContent withSidebar={true}>
          <Section title={'General'}>
            <DescriptionList
              stripEmpty={true}
              data={data}
              disableGutters={true}
              termWidth={'25%'}
            >
              <DescriptionItem label={'Type'} value={'Postback'} />
              <DescriptionItem label={'Event'} field={'eventType.name'} />
              <DescriptionItem label={'Application'} field={'app.name'} />
              <DescriptionItem
                label={'Business partners'}
                field={'businessPartners'}
                type={'typographyList'}
                unitsLabel={'Business partners'}
                listType={'bullet'}
                placeholder={'-'}
                limit={3}
              />
              <DescriptionItem label={'Traffic'} field={'trafficType.name'} />
              <DescriptionItem
                label={'Activity Type'}
                field={'activityType.name'}
              />
              <DescriptionItem
                label={'Affiliates'}
                field={'affiliates'}
                type={'typographyList'}
                unitsLabel={'Affiliates'}
                listType={'bullet'}
                placeholder={'All'}
                limit={3}
              />
              <DescriptionItem
                label={'Regs'}
                field={'includeRejected'}
                valueParser={(value) =>
                  `${value ? 'Include' : 'Exclude'} rejected`
                }
              />
              <DescriptionItem
                label={'Registration countries'}
                field={'regActionCountries'}
                type={'typographyList'}
                unitsLabel={'Registration countries'}
                listType={'bullet'}
                placeholder={'All'}
                limit={3}
              />
              <DescriptionItem
                label={'Events countries'}
                field={'eventCountries'}
                type={'typographyList'}
                unitsLabel={'Events countries'}
                listType={'bullet'}
                placeholder={'All'}
                limit={3}
              />
            </DescriptionList>
          </Section>
          {data?.strategies?.map(
            ({ requestUrlTemplate, conditions, isFinal }, i) => (
              <Section
                title={`Strategy ${i + 1}${isFinal ? ' (final)' : ''}`}
                isCollapsable={true}
                key={i}
              >
                <Stack spacing={2}>
                  <Typography color={'textSecondary'}>
                    {requestUrlTemplate}
                  </Typography>
                  {conditions?.length ? (
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell width={'25%'}>Targeting</TableCell>
                            <TableCell>Entities</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {conditions.map(({ targetProperty, values }, i) => (
                            <TableRow key={i}>
                              <TableCell>{targetProperty.name}</TableCell>
                              <TableCell>
                                {values.map(({ name }) => name).join(', ')}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : null}
                </Stack>
              </Section>
            )
          )}
        </SidePage.NewContent>
        <SidePage.Sidebar
          actions={
            <Actions
              actions={data?.actions}
              data={data}
              type={TYPE_POSTBACK}
              onDuplicate={handleDuplicate}
              onEdit={handleEdit}
              onRemove={handleRemove}
            />
          }
        >
          <Metadata data={data} />
        </SidePage.Sidebar>
        {childComponent}
      </SidePage.NewBody>
      {/*  </SidePage.Tab>*/}
      {/*  <SidePage.Tab label={TAB_ACTIONS_LOG}>*/}
      {/*    <SidePage.NewBody>*/}
      {/*      <ActionsLog data={data?.actionsLog} />*/}
      {/*    </SidePage.NewBody>*/}
      {/*  </SidePage.Tab>*/}
      {/*</SidePage.Tabs>*/}
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
    </SidePage>
  );
};

export default IntegrationPostbackDetails;
